import { useEffect, useState } from "react";

function pageIsVisible() {
	return typeof document === "undefined" || !document.hidden;
}

export function usePageVisibility() {
	const [visible, setVisible] = useState(pageIsVisible);

	useEffect(() => {
		const updateVisibility = () => setVisible(pageIsVisible());
		document.addEventListener("visibilitychange", updateVisibility);
		return () => document.removeEventListener("visibilitychange", updateVisibility);
	}, []);

	return visible;
}
